import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://mzunalhoitapgthoksjn.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im16dW5hbGhvaXRhcGd0aG9rc2puIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTcwMTYzMjEsImV4cCI6MjA3MjU5MjMyMX0.fwglh_FS29vIhaT6NAzaLE5v6ZqkdQx83nxeoWrnN7Q'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})